import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserQuotaAccountList } from '../../api/userQuotaAccount';
import { message } from 'antd';

// 获取用户额度账户列表
export const fetchUserQuotaAccounts = createAsyncThunk(
  'userQuotaAccount/fetchUserQuotaAccounts',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getUserQuotaAccountList(params);
      return response.data;
    } catch (error) {
      message.error('获取用户额度账户列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  userQuotaAccountList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    searchParams: {
      userId: undefined,
      username: undefined,
      nickname: undefined,
      status: undefined,
      quotaSource: undefined,
      minRemainingQuota: undefined,
      maxRemainingQuota: undefined,
      startTime: undefined,
      endTime: undefined
    }
  }
};

const userQuotaAccountSlice = createSlice({
  name: 'userQuotaAccount',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userQuotaAccountList.searchParams = {
        ...state.userQuotaAccountList.searchParams,
        ...action.payload
      };
      
      // 如果传入了页码或每页条数，更新对应的值
      if (action.payload.page) {
        state.userQuotaAccountList.current = action.payload.page;
      }
      
      if (action.payload.size) {
        state.userQuotaAccountList.size = action.payload.size;
      }
    },
    resetSearchParams: (state) => {
      state.userQuotaAccountList.searchParams = {
        userId: undefined,
        username: undefined,
        nickname: undefined,
        status: undefined,
        quotaSource: undefined,
        minRemainingQuota: undefined,
        maxRemainingQuota: undefined,
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserQuotaAccounts.pending, (state) => {
        state.userQuotaAccountList.loading = true;
      })
      .addCase(fetchUserQuotaAccounts.fulfilled, (state, action) => {
        state.userQuotaAccountList.loading = false;
        state.userQuotaAccountList.data = action.payload.records;
        state.userQuotaAccountList.total = action.payload.total;
        state.userQuotaAccountList.current = action.payload.current;
        state.userQuotaAccountList.size = action.payload.size;
      })
      .addCase(fetchUserQuotaAccounts.rejected, (state) => {
        state.userQuotaAccountList.loading = false;
      });
  }
});

export const { setSearchParams, resetSearchParams } = userQuotaAccountSlice.actions;
export default userQuotaAccountSlice.reducer; 